import { render, staticRenderFns } from "./EnterUserInformation.vue?vue&type=template&id=b56f1456"
import script from "./EnterUserInformation.vue?vue&type=script&lang=js"
export * from "./EnterUserInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports